import PropTypes from 'prop-types';
import styles from './TeaserBlock.module.scss';

// Components
import RawHtml from '../RawHtml/RawHtml';
import YouTubeVideo from '../YouTubeVideo';
import Modal from '../Modal/Modal';

const TeaserBlock = ({ title = '', richText = '', modal = {}, video = {} }) => {
    return (
        <div className={styles['TeaserBlock']}>
            <div className={styles['TeaserBlock__Container']}>
                <div className={styles['TeaserBlock__Content']}>
                    <div className={styles['TeaserBlock__Title']}>
                        <h2>{title}</h2>
                    </div>
                    <div className={styles['TeaserBlock__Body']}>
                        <div className={styles['ThreeColumnModule__Column']}>
                            <RawHtml html={richText} />
                        </div>

                        <Modal {...modal}><RawHtml html={modal.content} /></Modal>
                    </div>
                </div>
                <div className={styles['TeaserBlock__VideoContainer']}>
                    <h2 className={styles['TeaserBlock__Title']}>{title}</h2>
                    <div className={styles['TeaserBlock__Video']}>
                        <YouTubeVideo
                            videoId={video.videoId}
                            title={video.title}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

TeaserBlock.propTypes = {
    title: PropTypes.string,
    richText: PropTypes.string,
    modal: PropTypes.object,
    video: PropTypes.object,
};

export default TeaserBlock;
